// eslint-disable-next-line no-unused-vars
import React, {useContext, lazy, useEffect} from "react";

const Select = lazy(() => import("../Select/Select"));
const Input = lazy(() => import("../Input"));
import {ConfigContext} from "./index";
import translations from "../../translations";

function Register(props) {

    // const theme = useContext(ThemeContext);
    const {
        handleInputValue,
        handleSelectChange,
        handleInputChange,
        config = "de",
        translation,
        setJobagentObject,
        errorObject
    } = useContext(ConfigContext);



    const {talentnetwork} = config;
    const WidgetHTML = () => {
        const listOfErrors = errorObject.map(obj => {
            return obj.name;
        });

        const elements = talentnetwork.map((element) => {
            const classList = [`tms-candidate-widget-item--${element.name}`, `tms-candidate-widget-type--${element.type}`, "tms-candidate-widget-item", listOfErrors.indexOf(element.name) > -1 ? "tms-has-error" : undefined, element.places ? "tms-has-places-autocomplete" : null];
            let htmlElement;
            switch (element.type) {

            case "select":
                htmlElement = <Select
                    translations={translation}

                    change={selectData => handleSelectChange(selectData, element)}
                    {...element} />;
                break;
            case "input":

                htmlElement = <Input showLabel={true}
                    translations={translation}
                    setJobagentObject={setJobagentObject}
                    {...element}
                    onChange={inputData => handleInputChange(inputData, element)}
                    value={handleInputValue(element) || ""} // No undefinded
                />;
                break;
            case "checkbox":

                delete element.showLabel;
                htmlElement = <>
                    <label htmlFor={`tms-${element.name}--${props.componentUUID}`}>
                        <input
                            id={`tms-${element.name}--${props.componentUUID}`}
                            onChange={inputData => handleInputChange(inputData, element)} {...element}
                            defaultValue={false}
                            value={handleInputValue(element)}
                        /><span dangerouslySetInnerHTML={{__html: element.label}}/>
                    </label>
                </>;
                break;

            default:
                break;
            }
            return <div className={classList.join(" ")} key={element.name}>{htmlElement}</div>;

        });

        return elements;

    };

    const tocMessage = () => {

        return window["myTalentionConfig"].dataprotectionSentence || translations[config.lang].candidateWidgetRegisterToc.replace("{myTalentionConfig.dataprotectionLink}", window["myTalentionConfig"].dataprotectionLink || "/datenschutz");

    };


    const customTextCandidateWidget = window["myTalentionConfig"]?.customTextCandidateWidget ||customTextCandidateWidget;
    const MaxResultsHeadlineTag =customTextCandidateWidget?.htmlTagHeadline || "h2";
    const MaxResultsCopyTag =customTextCandidateWidget?.htmlTagCopy || "p";

    const Intro = () => <header className={"tms-candidate-widget-register-header"}>
        <MaxResultsHeadlineTag>
            {customTextCandidateWidget?.registerHeadline || translations[config.lang].candidateWidgetRegisterHeadline}
        </MaxResultsHeadlineTag>
        <MaxResultsCopyTag>
            {customTextCandidateWidget?.registerCopy || translations[config.lang].candidateWidgetRegisterCopy}
        </MaxResultsCopyTag>
    </header>;
    return (<>
        <Intro/>

        {WidgetHTML()}
        <label htmlFor={`toc--${props.componentUUID}`}>
            <input

                value={undefined}
                onClick={(e) => {
                    handleInputChange(e, {
                        name: "toc",
                        property: false
                    });

                }} type="checkbox" name={"toc"} id={`toc--${props.componentUUID}`}/>

            <span dangerouslySetInnerHTML={{__html: tocMessage()}}/>
        </label>

    </>

    );
}

export default Register;
